import { ReactElement, useEffect, useMemo } from 'react';

import { CurrentHealthcareProviderConfiguration } from '@dreryk/egabinet-patient-portal-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';

import { useFormController } from '@dreryk/react-common';

import {
   HealthcareProviderConfigurationFormBean,
   HealthcareProviderConfigurationFormController,
} from './HealthcareProviderConfigurationForm.types';
import { formInitializer } from './HealthcareProviderConfigurationForm.utils';

type HealthcareProviderConfigurationFormChildrenRenderProps = Pick<
   HealthcareProviderConfigurationFormController,
   'register' | 'watch' | 'handleSubmit' | 'formState'
>;

type HealthcareProviderConfigurationFormProps = Readonly<{
   configuration: CurrentHealthcareProviderConfiguration | null;
   defaultAppointmentRequestsEmail: EmailAddress | null;
   children: (renderProps: HealthcareProviderConfigurationFormChildrenRenderProps) => ReactElement;
}>;

export const HealthcareProviderConfigurationForm = (props: HealthcareProviderConfigurationFormProps): ReactElement => {
   const initialValues = useMemo(() => formInitializer(props.configuration, props.defaultAppointmentRequestsEmail), [
      props.configuration,
      props.defaultAppointmentRequestsEmail,
   ]);
   const {
      register,
      handleSubmit,
      formState,
      watch,
      sync,
   } = useFormController<HealthcareProviderConfigurationFormBean>(initialValues, {
      resetAfterSubmit: true,
      shouldUnregister: false,
   });

   const appointmentRequestsEmail = props.configuration?.requestsForAppointmentConfiguration.appointmentRequestsEmail;

   useEffect(() => {
      if (appointmentRequestsEmail) {
         sync({ appointmentRequestsEmail: appointmentRequestsEmail });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [appointmentRequestsEmail]);

   return props.children({ register: register, watch: watch, handleSubmit: handleSubmit, formState: formState });
};
